import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get("token");
      const error = searchParams.get("error");

      if (error) {
        // eslint-disable-next-line no-console
        console.error("Authentication error:", error);
        navigate(`/login?error=${error}`);
        return;
      }

      if (token) {
        // トークンをローカルストレージに保存
        localStorage.setItem("auth_token", token);

        // 認証状態を更新
        await checkAuth();

        // ダッシュボードにリダイレクト
        navigate("/dashboard");
      } else {
        navigate("/login?error=no_token");
      }
    };

    handleCallback();
  }, [searchParams, navigate, checkAuth]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-gray-600">認証処理中...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
